module.exports = __webpack_public_path__ + "img/banner-12.42f5f06e.jpg";